import React from "react";
import "./MyCoursesHeading.css";

const MyCoursesHeading = () => {
  return (
    <div>
      <div className="myCoursesHeadingBiggerBox">
        <div className="myCoursesHeading">My Courses</div>
      </div>
    </div>
  );
};

export default MyCoursesHeading;
